import React from 'react';
import { Box, Typography, Stack, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PushNotificationSendTab from './components/PushNotificationSendTab';

const AppNotifications = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
        <Typography sx={{ fontSize: 18, fontWeight: 500 }}>Uygulama Bildirimleri</Typography>
        <Button
          onClick={() => navigate('/notifications/app-notifications/records')}
          sx={{
            textTransform: 'none',
            fontSize: '13px',
            fontWeight: 500,
            backgroundColor: 'transparent',
            color: '#0E4D94',
            textDecoration: 'underline',
            '&:hover': {
              backgroundColor: 'transparent',
              textDecoration: 'underline',
            },
          }}
        >
          Gönderim Kayıtları
        </Button>
      </Stack>
      <PushNotificationSendTab />
    </Box>
  );
};

export default AppNotifications;
